<template>
  <div class="container-background">
    <m-f301 class="custom-footer "/>

  </div>
</template>

<script>

export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {},
  computed: {},
  async mounted() {
  }
};
</script>

<style scoped>

</style>